export enum SaleType {
  overTheCounter = 1, // Venta libre
  prescriptionOnly = 2, // Venta bajo receta
  archivedPrescription = 3, // Venta bajo receta archivada
  officialPrescription = 4, // Venta bajo receta oficial
  pending = 5, // Pendiente
  medicalSupervision = 6, // Bajo control médico recomendado
  unclassified = 7 // No clasificado
}
